import * as React from 'react';
import { useFrameHooks } from '@xingternal/hub';
const InternalLink = ({ to, ...props }) => {
    const { useLinkComponent } = useFrameHooks();
    const A = ({ to, ...props }) => (React.createElement("a", { href: to, ...props }));
    const getFallbackComponent = () => A;
    const getComponent = (useLinkComponent || getFallbackComponent);
    if (to !== undefined) {
        if (typeof to === 'string') {
            const Component = getComponent(to);
            return React.createElement(Component, { to: to, ...props });
        }
        // If `to` is defined, but not a string url, we assume it's a Router's to configuration object
        const Component = getComponent(true);
        return React.createElement(Component, { to: to, ...props });
    }
    // This case catches props `onClick` only and `href` only
    const Component = getComponent(false);
    return React.createElement(Component, { ...props });
};
export const Link = InternalLink;
//# sourceMappingURL=index.js.map